// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"c1bc364e","222":"785db62a","278":"8a425f12","347":"dac88a7c","430":"739df93d","545":"3b7311ef","592":"2e3d1439","626":"0a9c025d","787":"1c3aeb8b","926":"24d72669"}[chunkId] + ".chunk.js";
};